import * as React from 'react';
import TextField from '@mui/material/TextField';
import deLocale from 'date-fns/locale/de';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

const errorMsg = (props) => {
  if (!props.touched) {
    return "";
  }

  if(!props.hasOwnProperty("validator")) {
    return "";
  }

  if (props.validator().valid === true) {
    return "";
  }

  return props.validator().message;
    
}

const CustomDatePickerFieldNGX = (props) => {

  return (

      <LocalizationProvider dateAdapter={AdapterDateFns} locale={deLocale}>
        <DatePicker
          label={props.label}
          value={aktuellesDatum(props.value)}
          mask='__.__.____'
          disableFuture={true}
          format="dd.MM.yyyy"
          onChange={(newValue, e) => {
            if (newValue =="Invalid Date") {
              return;
            }
            let datum = new Date(newValue)
            //let isoString = datum.toISOString().substring(0,10)
            let isoString = formatDate(
              datum.getFullYear(),
              datum.getMonth()+1,
              datum.getDate()
            )

            props.updaterValue(isoString)
          }}
          renderInput={
            (params) => (
              <TextField 
                {...params}
                fullWidth
                required={props.required}
                onBlur={()=>props.updaterTouch(true)}
                error={errorMsg(props)!==""}
                helperText={errorMsg(props)}
              />
            )
          }
        />
      </LocalizationProvider>
  );
}

const aktuellesDatum = (value) => {
    if (value) {
      return value
    }
    return null
}

const formatDate = (year, month, day) => {
  let r = ''+year
  month < 10 ? r = r+'-0'+month : r = r+'-'+month
  day < 10 ? r = r+'-0'+day : r = r+'-'+day
  return r;
}

export default CustomDatePickerFieldNGX;


